define(['jquery'], function($){
	"use strict";

	var PLUGIN_NAME = "rwdBackground";
	var PLUGIN_VERSION = "v01";

	var DEFAULTS = {
		selector : 'bg-rwd'
	};

	// The actual plugin constructor
	var RwdBackground = function ( element, options ) {

		this.element = element;
		this.$t = $(this.element);

		this.options = $.extend(true, {}, DEFAULTS, options );
		this._defaults = DEFAULTS;

		this.attrString = 'data-'+this.options.selector+'-';
		this.attrString2 = this.options.selector+'-';

		this.initialise();
	};

	/**
	 * init function
	 */
	RwdBackground.prototype.initialise = function() {

		this.getAttributes();
		this.setRwdBackground();
		this.bindEvents();

		this.resizeTimer = null;
	};


	RwdBackground.prototype.setRwdBackground = function() {

		var browserWidth = window.innerWidth;
		if (!this.$t || !this.$t.data('attributes')) {
			return false;
		}
		var arrayLength = this.$t.data('attributes').length;
		var attrStringLength;

		if (arrayLength == 0) {
			attrStringLength = this.attrString.length;
			this.$t.css('background-image', 'url(' + this.$t.attr(this.attrString.substr(0,(attrStringLength-1))) + ')');
		} else {
			for (var i = 0; i < arrayLength; i++) {
				if (browserWidth <= this.$t.data('attributes')[i]) {
					this.$t.css('background-image', 'url(' + this.$t.attr(this.attrString+this.$t.data('attributes')[i]) + ')');
					return false;
				}
				if (browserWidth >= this.$t.data('attributes')[i]) {
					attrStringLength = this.attrString.length;
					this.$t.css('background-image', 'url(' + this.$t.attr(this.attrString.substr(0,(attrStringLength-1))) + ')');
				}
	/*
				if (this.$t.data('attributes')[i] >= browserWidth) {
					this.$t.css('background-image', 'url(' + this.$t.attr(this.attrString+this.$t.data('attributes')[i]) + ')');
					return false;
				}
				if (i == (arrayLength -1)&& browserWidth > this.$t.data('attributes')[i]) {
					this.$t.css('background-image', 'url(' + this.$t.attr(this.attrString+this.$t.data('attributes')[i]) + ')');
				};
	*/
			}
		}

	};


	RwdBackground.prototype.getAttributes = function() {

		var attributes = [];
		var self = this;
		//var attributes = {};

		if( this.$t.length ) {
			$.each( this.$t[0].attributes, function( index, attr ) {
				//attributes[ attr.name ] = attr.value;
				if (attr.name.indexOf(self.attrString) == 0) {
					attributes.push(parseInt(attr.name.substring(self.attrString.length)));
				}
			});

			var sortedArray = attributes.sort(function (a, b) {
				return a - b;
			});

			this.$t.data('attributes', sortedArray);

		}

	};


	RwdBackground.prototype.bindEvents =  function() {

		var self = this;

		$(window).bind('resize.rwd.background', function() {
			clearTimeout(self.resizeTimer);
			self.resizeTimer = setTimeout(function() {
				self.setRwdBackground();
			}, 200);
		});

	};

	/**
	 * decide, which methods will be "public"
	 */
	var API = {
		setRwdBackground: RwdBackground.prototype.setRwdBackground
	};

	/**
	 * plugin go live
	 * @param value - first param - decides, which action shall be executed
	 * 		if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
	 * 		if string && in API object - run method named as this value with all args[index > 0]
	 * @return {*}
	 */
	$.fn[PLUGIN_NAME] = function (value) {
		var args = arguments;

		return this.each(function () {
			var $this = $(this);
			// get plugin instance
			var plugin = $this.data('plugin_' + PLUGIN_NAME);

			// if there's not, create one
			if (!plugin) {
				plugin = new RwdBackground(this, value);
				$this.data('plugin_' + PLUGIN_NAME, plugin);

			}
			// if there is and first parameter is in predefined API methods, call it with rest of params
			else if (API[value]) {
				plugin[value].apply(plugin, Array.prototype.slice.call(args, 1));
			}
		});
	};


	/**
	 * setDefaults with $.googlemap.setDefaults();
	 */
	$[PLUGIN_NAME] = $.fn[PLUGIN_NAME];
	$[PLUGIN_NAME].setDefaults = function(newOptions) {
		DEFAULTS = $.extend(true, {}, DEFAULTS, newOptions);
	};

});


// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/jquery.rwdBackground.js